import React, { useEffect, useState } from 'react';
import OdxModal from "../../../../OdxComponents/NativeOdx/Modal/Odx-Modal";
import OdxInputField from "../../../../OdxComponents/NativeOdx/FormControls/Odx-InputField";
import OdxRadioButton from "../../../../OdxComponents/NativeOdx/FormControls/Odx-RadioButton";

interface DateRangeModalProps {
    isOpen: boolean;
    from: string;
    to: string;
    onClose: () => void;
    onApply: (from: string, to: string) => void;
}

const dateRangeOptions = {
    custom: 'custom',
} as const;

type DateRangeOption = typeof dateRangeOptions[keyof typeof dateRangeOptions];

const DateRangeModal: React.FC<DateRangeModalProps> = ({
                                                           isOpen,
                                                           from,
                                                           to,
                                                           onClose,
                                                           onApply,
                                                       }) => {
    const [selectedOption, setSelectedOption] = useState<DateRangeOption>(dateRangeOptions.custom);
    const [_from, set_From] = useState<string>(from);
    const [_to, set_To] = useState<string>(to);

    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value as DateRangeOption;
        setSelectedOption(value);
    };

    return (
        <OdxModal
            size="small"
            title="Date Picker"
            isOpen={isOpen}
            variant="sidesheet"
            onClose={onClose}
            footerButtons={[
                <odx-button
                    key="cancel"
                    variant="ghost"
                    size="sm"
                    type="button"
                    onClick={onClose}
                >
                    Cancel
                </odx-button>,
                <odx-button
                    key="apply"
                    id={`OdxButton_DatePickerModal_Apply`}
                    variant="primary"
                    size="sm"
                    type="button"
                    onClick={() => onApply(_from, _to)}
                >
                    Apply
                </odx-button>,
            ]}
        >
            <div>
                <div style={{ marginBottom: '16px' }}>
                    <OdxRadioButton
                        name="dateRange"
                        value={dateRangeOptions.custom}
                        id={"DatePickerModal_Preset_Custom"}
                        label="Custom Dates"
                        checked={selectedOption === dateRangeOptions.custom}
                        onChange={handleRadioChange}
                    />
                </div>
                <odx-separator style={{margin: '1rem 0'}} />
                <div className="flex space-x-4">
                    <div>
                        <OdxInputField
                            isRequired={false}
                            label="From"
                            id="from"
                            placeholder="From Date"
                            type="date"
                            value={_from}
                            onChange={(event) => {
                                set_From(event.target.value);
                            }}
                            isDisabled={selectedOption !== dateRangeOptions.custom}
                        />
                    </div>
                    <div>
                        <OdxInputField
                            isRequired={false}
                            label="To"
                            id="to"
                            placeholder="To Date"
                            type="date"
                            value={_to}
                            onChange={(event) => {
                                set_To(event.target.value);
                            }}
                            isDisabled={selectedOption !== dateRangeOptions.custom}
                        />
                    </div>
                </div>
            </div>
        </OdxModal>
    );
};

export default DateRangeModal;
